export const checkIfStartsWithParagraph = (text: string) => {
    return text?.startsWith("<p")
}
